import { schema } from "normalizr";

export const simulator = new schema.Entity("simulators");
